<template>
	<aside
		class="c-content-sidebar__facet-wrapper c-content-sidebar__facet-wrapper--align"
		:class="{ 'c-content-sidebar__facet-wrapper--show': showFilters }"
		data-testid="content-filters-sidebar"
	>
		<div class="c-content-sidebar__button-group">
			<ds-button
				v-if="Object.keys(activeLibraryFilters).length"
				type="button"
				variant="link"
				size="sm"
				class="c-content-sidebar__button-reset"
				:click-handler="() => resetFilters()"
			>
				{{ resetFiltersLabel }}
			</ds-button>
			<ds-icon-button
				type="button"
				aria-label="Close"
				icon-name="close"
				variant="tertiary"
				class="c-content-sidebar__button-close"
				:click-handler="() => toggleFilters()"
			>
			</ds-icon-button>
		</div>
		<form class="c-content-sidebar__facet-list c-content-sidebar__facet-list--align">
			<div class="c-content-sidebar__facet-list-label c-content-sidebar__facet-list-label--align">{{ filtersLabel }}</div>
			<div class="c-content-sidebar__facet-list-content">
				<content-facet-group
					v-for="(group, index) in contentFacetGroups"
					:key="group.id"
					:group="group"
					:index="index"
				/>
			</div>
		</form>
		<div
			v-if="formattedApplyFilterLabel"
			class="c-content-sidebar__button-block"
		>
			<ds-button
				type="button"
				variant="primary"
				:click-handler="() => toggleFilters(true)"
			>
				{{ formattedApplyFilterLabel }}
			</ds-button>
		</div>
	</aside>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex';
	import contentFacetGroup from 'shared/components/contentLibrary/contentFacetGroup.vue';
	import { DsButton, DsIconButton } from '@coloplast/design-system';

	export default {
		name: 'content-filters-sidebar',
		components: { contentFacetGroup, DsButton, DsIconButton },
		props: ['filtersLabel', 'resetFiltersLabel', 'showFilters', 'bothFiltersTypesApplied', 'formattedApplyFilterLabel'],
		emits: ['toggle-filters'],
		computed: {
			...mapGetters({
				activeLibraryFilters: 'getActiveLibraryFilters',
				contentFacetGroups: 'getContentFacetGroups',
			}),
		},
		methods: {
			...mapActions(['resetContentFacetGroups', 'resetCurrentFacetGroups']),
			toggleFilters(applyFilters) {
				this.$emit('toggle-filters');
			},
			resetFilters() {
				if (this.bothFiltersTypesApplied) {
					this.resetCurrentFacetGroups();
				}
				else {
					this.resetContentFacetGroups();
				}
			},
		},
	};
</script>
